import * as ng from 'angular';
import { BaseUrlService } from '../../services/base-url.service';
import { rabbitMQ } from '../../third/rabbitMQ';
import { ArchiSmallServices } from '../../services/archismall.service';


export class UserSettingsController implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$scope',
        '$state',
        'ArchiSmallServices',
        'store',
        '$uibModal',
        'BaseUrlService',
        'configuration',
        '$http'
    ];

    constructor(
        private $rootScope: any,
        private $scope: any,
        private $state: ng.ui.IStateService,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private baseUrlService: BaseUrlService,
        private configuration: any, // todo specificare il tipo
        private $http: ng.IHttpService
    ) {
        $scope.pageHeader = 'Impostazioni';
        $scope.tooltips = {
            'home': 'Torna alla pagina principale.',
            'rubrica': 'Aggiungi, modifica e gestisci i tuoi contatti.',
            'help': 'Ti serve Aiuto? Leggi il Manuale o apri un\nticket e verrai contattato dal Servizio Assistenza.',
            'notifications': 'ArchiSMALL ti tiene aggiornato sulle operazioni eseguite.\nClicca sulle singole notifiche per consultarle.',
            'user': 'Gestisci il tuo Profilo e la tua Rubrica.',
            'userSettings': 'Completa o modifica le informazioni\nrelative al tuo account ArchiSMALL.',
            'storageLimit': 'Controlla lo spazio del tuo ArchiSMALL.',
            'signOut': 'Esci da ArchiSMALL.'
        };

        if (!$rootScope.currentUser()) {
            $state.go('login');
        } else {
            ArchiSmallServices.getUser($rootScope.currentUser().sub)
                .then((response: any) => {
                    $rootScope.user = response;
                    store.set('user', response);
                    $rootScope.user.organizationData.contactPerson.birthDate = $rootScope.formatDateValue($rootScope.user.organizationData.contactPerson.birthDate);
                    $rootScope.user.organizationData.periodStart = $rootScope.formatDateValue($rootScope.user.organizationData.periodStart);
                    $rootScope.user.organizationData.periodEnd = $rootScope.formatDateValue($rootScope.user.organizationData.periodEnd);
                    if ($rootScope.user.organizationData.alboProfessionale !== undefined && $rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo !== '') {
                        $rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo = $rootScope.formatDateValue($rootScope.user.organizationData.alboProfessionale.dataIscrizioneAlbo);
                    }
                    ArchiSmallServices.rabbitMQConfig()
                        .then((response: any) => {
                            rabbitMQ.init(response.user, response.password, configuration.testEnvironment);
                            $rootScope.startNotificationWorker();
                        }, (error) => {
                            $rootScope.alert('error', error);
                        });
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        }
        $scope.closeAlert = (index) => {
            store.set('showAlert', false);
        };

        $scope.getNotificationClass = (item) => {
            return {
                'icon-icon_scarica': ['archidrive',
                    'archidrive-multiple'
                ].indexOf(item.type) > -1,
                'icon-icon_consulta': item.type === 'conservato',
                'icon-icon_conserva': [
                    'conservazione',
                    'conservazione-fatture-attive',
                    'conservazione-fatture-attive-versamento',
                    'conservazione-fatture-pa-e-notifiche',
                    'conservazione-fatture-attive-enabled',
                    'conservazione-pec',
                    'conservazione-pec-versamento',
                    'conservazione-fattura-gse-e-notifiche',
                    'conservazione-fatture-elettronica-passiva'
                ].indexOf(item.type) > -1,
                'icon-icon_fattura': [
                    'fattura-pa-status',
                    'fattura-pr-status',
                    'fattura-passiva-status'
                ].indexOf(item.type) > -1
            };
        };
    }
}


export const UserSettingsComponent: ng.IComponentOptions = {
    template: require('./usersettings.html'),
    controller: UserSettingsController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/usersettings.ts